import { useNavigate } from "react-router-dom";
import { Grid, Card } from "@mui/material";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import salesTableData from "layouts/sales/data/salesTableData";
import CustomPagination from "examples/CustomPagination/CustomPagination";
import useSales from "hooks/useSales";
import { useEffect, useState } from "react";
import useDashboard from "hooks/useDashboard";
import { debounce } from "lodash";

function Tables() {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { getSalesList, salesList } = useSales();
  const { sidenavColor } = controller;
  const { columns, rows } = salesTableData();
  const { searchTerm } = useDashboard();
  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [total, setTotal] = useState(0);

  // Function to fetch
  const fetchSales = () => {
    const query = searchTerm.length >= 3 ? searchTerm : ""; // Apply search only if length >= 3
    getSalesList({ limit, page, search: query });
  };

  // Debounced search function
  const debouncedfetchSales = debounce(fetchSales, 500);

  // Initial Load (Mandatory)
  useEffect(() => {
    fetchSales(); // Always fetch initial data on mount
  }, []);

  // Search & Pagination Updates
  useEffect(() => {
    if (searchTerm.length === 0 || searchTerm.length >= 3) {
      debouncedfetchSales();
    }
    return () => debouncedfetchSales.cancel(); // Cleanup debounce
  }, [searchTerm, page, limit]);
  // Update pagination state when dealerList updates
  useEffect(() => {
    if (salesList.page && salesList.limit) {
      setPage(salesList.page);
      setLimit(salesList.limit);
      setTotalPage(salesList.pages || 1);
      setTotal(salesList.total || 0);
    }
  }, [salesList]);
  // Handle page change
  const handlePageChange = (newPage) => {
    setPage(newPage);
    getSalesList({ limit: 10, page: newPage });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  Sales Team
                </MDTypography>
                <MDButton onClick={() => navigate("/sales-team/create")}>Create Sales</MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
            <MDBox
              sx={{ width: "100%", display: "flex", justifyContent: "start", marginTop: "1rem" }}
            >
              <CustomPagination
                totalCount={totalPage}
                currentPage={page}
                onPageChange={handlePageChange}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Tables;
